<template>
  <rest-form-item :label="tooltip ? '' : label" :prop="prop">
    <el-select
      v-model="model"
      filterable
      remote
      :placeholder="placeholder || $t('Integration_Placeholder')"
      :remote-method="fetchIntegrationsDropdown"
      :clearable="clearable"
      v-loading="loadingIntegrations"
      :disabled="readOnly"
    >
      <el-option
        v-if="placeholder"
        :value="null"
        :label="placeholder || $t('Integration_Placeholder')"
      />
      <el-option
        v-for="item in integrations"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
    <template v-if="tooltip" #label>
      {{ label }}
      <form-item-i-tooltip :tooltip-content="tooltip" />
    </template>
  </rest-form-item>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormItemITooltip from '@/common/components/form/FormItemITooltip.vue'
import RestApi from '@/core/services/RestApi'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'IntegrationSelect',

  components: {
    FormItemITooltip,
    RestFormItem
  },

  data() {
    return {
      loadingIntegrations: true,
      integrations: {}
    }
  },

  props: {
    prop: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    tooltip: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    predefined: {
      type: [Boolean, Array],
      required: false
    }
  },

  mounted() {
    this.fetchIntegrations()
  },

  computed: {
    model: {
      get() {
        if (this.value && Number.isInteger(this.value)) {
          return parseInt(this.value)
        }

        return undefined
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    fetchIntegrations() {
      this.loadingIntegrations = true
      const params = {
        type: 'otp',
        active: 1,
        'per-page': 50
      }

      if (this.value) {
        params.include_id = this.value
      }

      new RestApiPaginator(
        projectEndpoint({
          method: 'get',
          url: `integrations`,
          params: params
        })
      )
        .fetchPage(1)
        .then(({ data }) => {
          this.integrations = data
          this.loadingIntegrations = false
        })
    },

    fetchIntegrationsDropdown(query) {
      this.loadingIntegrations = true

      let params = {
        type: 'otp',
        sort: 'name',
        'per-page': 50
      }

      if (query !== null && query !== '') {
        params.title = query
      }

      let endpoint = projectEndpoint({
        method: 'get',
        url: 'integrations',
        params: params
      })

      RestApi(endpoint)
        .then(({ data }) => {
          this.integrations = data
          this.loadingIntegrations = false
        })
        .catch(error => {
          this.loadingIntegrations = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/integration/IntegrationSelect.vue